<template>
  <div id="guidance-cta" class="lg:mx-0 pb-4 px-6 bg-half-white-dark" v-if="activeTab === 0 && !isExpiringIntegratedUser">
    <div class="bg-yellow-200 text-black py-8 px-6 max-w-1090 lg:mx-auto rounded-lg">
      <div class="flex items-center flex-col md:flex-row md:space-x-4">
          <div class="flex w-full md:w-auto">
            <div class="mb-5">
              <img 
                class="flex" 
                src="https://cdn.sportsrecruits.com/assets/recruiting-guidance-support-avatar.svg" 
                alt="guidance-illustration"
                width="96" 
                height="79"
              >
            </div>
          </div>
          <div class="flex flex-col">
            <h4 class="m-0 p-0 mb-3 ds-text-3xl font-bold">Looking for Expert Guidance in Your Recruiting Process?</h4>
            <p class="mb-5 ds-text-base font-normal">We’ll help you understand the overall process, recruiting timeline, and how to get your information in front of college coaches. Check out our Recruiting Guidance Plans which include a lifetime Pro account.</p>
            <div>
              <Button
              text="See Recruiting Guidance Options"
              emphasis="medium"
              color="blue"
              @click="handleTabChange(tabs[1])"
              textColor="text-blue-300"
              class="recruiting-guidance-btn"
              />
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: { type: Array, required: true },
    activeTab: {type: Number, required: true},
    isExpiringIntegratedUser: { type: Boolean | Number, required: true}
  },
  methods: {
    handleTabChange(tab) {
        this.$emit('handleTabChange', tab)
    }
  }
}
</script>

<style>
.max-w-1090 {
  max-width: 1090px;
}

.bg-half-white-dark {
  background-image: linear-gradient(
    to top,
    rgba(23, 25, 36, 1) 96px,
    white 96px
  );
}

@media screen and (max-width: 768px) {
  button.recruiting-guidance-btn {
    width: 100% !important;
  }
}
</style>
